import MobileInfo from './MobileInfo';

export default MobileInfo;
